module.exports = __webpack_public_path__ + "static/media/key.c28164d0.svg";